import api from '../lib/api';
import {
  PaginatedResponse,
  ReleaseNotePreview,
  ReleaseNoteRecipient,
  ReleaseNoteSendBody,
  ReleaseNoteSendResult,
  ReleaseNoteSendRow,
  ReleaseNoteSummary,
} from '../types';

const BASE = '/api/v1/admin/release-notes';

export interface ReleaseNoteSendFilters {
  page?: number;
  limit?: number;
  version?: string;
}

export const releaseNotesApi = {
  list: (signal?: AbortSignal) => api.get<ReleaseNoteSummary[]>(BASE, { signal }),
  get: (version: string, signal?: AbortSignal) => api.get<ReleaseNotePreview>(`${BASE}/${version}`, { signal }),
  recipients: (version: string, signal?: AbortSignal) =>
    api.get<ReleaseNoteRecipient[]>(`${BASE}/${version}/recipients`, { signal }),
  sends: (params: ReleaseNoteSendFilters, signal?: AbortSignal) =>
    api.get<PaginatedResponse<ReleaseNoteSendRow>>(`${BASE}/sends`, { params, signal }),
  send: (version: string, body: ReleaseNoteSendBody) =>
    api.post<ReleaseNoteSendResult>(`${BASE}/${version}/send`, body),
};
